import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import SearchComponent from '../../../PricingHub/SearchComponent';

class OperatorMapSearchForm extends SearchComponent {
  searchInputs = [
    {
      label: 'common:label.serviceType',
      name: 'serviceType',
      tOptions: 'selections:serviceType',
      type: 'select',
      defaultValue: 'VOICE',
      required: true,
    },
    {
      label: 'label.operatorId',
      name: 'operatorId',
    },
    {
      label: 'label.operatorName',
      name: 'operatorName',
    },
  ];

  btnSpan = 'col-md-3';
}

OperatorMapSearchForm.propTypes = {
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
};

OperatorMapSearchForm.defaultProps = {
  isSubmitting: false,
};

export default withTranslation('common')(OperatorMapSearchForm);
